import React from 'react';
import isEmpty from 'lodash/isEmpty';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import NewMeta from '../../components/Forms/NewMeta'
import BackButton from '../../components/Buttons/BackButton'
import DeleteButton from '../../components/Buttons/DeleteButton';
import useStyles from '../styles';

const Form = ({data, onUpdate, onCreate, onDelete, onClose}) => {

  const classes = useStyles();

  return isEmpty(data)
    ? <NewMeta title={
      <Grid
        container
        justify='space-between'
        alignItems='center'
        className={classes.title}
      >
        <Typography variant='h6'>
          Adicionar Veículo
        </Typography>
      </Grid>
      } submitForm={onCreate}
    />
    : <NewMeta
      title={
        <Grid container >
          <Grid item>
            <BackButton onClick={onClose}/>
          </Grid>
          <Grid
            container
            justify='space-between'
            alignItems='center'
            className={classes.title}
          >
            <Grid item>
              <Typography variant='h6'>
                Editar Veículo
              </Typography>
            </Grid>
            <Grid item>
              <DeleteButton onClick={onDelete}/>
            </Grid>
          </Grid>
        </Grid>
      }
      meta={data}
      submitForm={onUpdate}
      update
    />
};

export default Form;
